import ReactGA from 'react-ga4';

export const initGA = measurementId => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize(measurementId);
  }
};

export const pageview = path => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const event = (category, action, label, params = {}) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.event({
      category,
      action,
      label,
      ...params,
    });
  }
};

export const EVENTS = {
  USER_REGISTRATION: 'user_registration',
  GAME_START: 'game_start',
  HAND_SUBMITTED: 'hand_submitted',
  CARD_SWAP: 'card_swap',
  VIEW_RESULTS: 'view_results',
  REFERRAL_LINK_COPY: 'referral_link_copy',
  COIN_PURCHASE: 'coin_purchase',
};
